"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyConfigurationMenu = exports.OpenSankeyConfigurationsMenus = void 0;
// Standard libs
const react_1 = __importStar(require("react"));
// Imported libs
const react_2 = require("@chakra-ui/react");
// Local libs
const SankeyMenuConfigurationNodes_1 = __importDefault(require("./SankeyMenuConfigurationNodes"));
const SankeyMenuConfigurationLinks_1 = __importDefault(require("./SankeyMenuConfigurationLinks"));
/**
 *  Define configuration menu
 *
 * @param { TODO type } dict_variable_application_data - TODO description
 * @param { TODO type } dict_variable_elements_selected - TODO description
 * @param { TODO type } applicationContext - TODO description
 * @param { TODO type } uiElementsRef - TODO description
 * @param { TODO type } dict_hook_ref_setter_show_dialog_components - TODO description
 * @param { TODO type } menu_configuration_layout - TODO description
 * @param { TODO type } menu_configuration_node_tags - TODO description
 * @param { TODO type } menu_configuration_link_tags - TODO description
 * @param { TODO type } menu_configuration_data_tags - TODO description
 * @param { TODO type } menu_configuration_nodes - TODO description
 * @param { TODO type } menu_configuration_links - TODO description
 * @param { TODO type } additional_accordion_edition_elements - TODO description
 * @param { TODO type } token - TODO description
 *
 */
const OpenSankeyConfigurationsMenus = (dict_variable_application_data, dict_variable_elements_selected, applicationContext, uiElementsRef, dict_hook_ref_setter_show_dialog_components, menu_configuration_layout, menu_configuration_node_tags, menu_configuration_link_tags, menu_configuration_data_tags, menu_configuration_nodes, menu_configuration_links, additional_accordion_edition_elements, token, link_function, ComponentUpdater, contextMenu, alt_key_pressed, node_function) => {
    // const [subnavitemactive, setsubnavitemactive] = useState('')
    // const [nav_index, setNavIndex] = useState(-1)
    // const { ref_setter_nav_item_active, ref_setter_sub_nav_item_active, ref_nav_item_active} = uiElementsRef
    // ref_setter_nav_item_active.current = setNavIndex
    // ref_setter_sub_nav_item_active.current = setsubnavitemactive
    // ref_nav_item_active.current = nav_index
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    ComponentUpdater.updateComponentMenuConfig.current = () => setForceUpdate(!forceUpdate);
    const { data } = dict_variable_application_data;
    const { t } = applicationContext;
    const { links_accordion_ref, nodes_accordion_ref, accordion_ref } = uiElementsRef;
    const { multi_selected_nodes } = dict_variable_elements_selected;
    // const {ref_setter_show_menu_config}=dict_hook_ref_setter_show_dialog_components
    const show_menu_config_tag = ((data.accordeonToShow.includes('EN') ||
        data.accordeonToShow.includes('EF') ||
        data.accordeonToShow.includes('ED')));
    return [
        data.accordeonToShow.includes('MEP') ?
            react_1.default.createElement(react_2.AccordionItem, null,
                react_1.default.createElement(react_2.AccordionButton, null,
                    react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfig_entry' }, t('Menu.MEP')),
                    react_1.default.createElement(react_2.AccordionIcon, null)),
                react_1.default.createElement(react_2.AccordionPanel, null,
                    react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_grid' }, menu_configuration_layout.map((c, i) => {
                        return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
                    })))) :
            react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(react_2.AccordionItem, null,
            react_1.default.createElement(react_2.AccordionButton, { ref: accordion_ref },
                react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfig_entry' }, t('Menu.Elements')),
                react_1.default.createElement(react_2.AccordionIcon, null)),
            react_1.default.createElement(react_2.AccordionPanel, null,
                react_1.default.createElement(react_2.Accordion, { allowToggle: true, variant: 'accordion_sublevel_style' },
                    react_1.default.createElement(react_2.AccordionItem, null,
                        react_1.default.createElement(react_2.AccordionButton, { ref: nodes_accordion_ref },
                            react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'submenuconfig_entry' }, t('Menu.EdN')),
                            react_1.default.createElement(react_2.AccordionIcon, null)),
                        react_1.default.createElement(react_2.AccordionPanel, null,
                            react_1.default.createElement(SankeyMenuConfigurationNodes_1.default, { applicationContext: applicationContext, dict_variable_application_data: dict_variable_application_data, dict_variable_elements_selected: dict_variable_elements_selected, multi_selected_nodes: multi_selected_nodes, menu_configuration_nodes: menu_configuration_nodes, token: token, link_function: link_function, ComponentUpdater: ComponentUpdater, node_function: node_function }))),
                    react_1.default.createElement(react_2.AccordionItem, null,
                        react_1.default.createElement(react_2.AccordionButton, { ref: links_accordion_ref },
                            react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'submenuconfig_entry' }, t('Menu.EdF')),
                            react_1.default.createElement(react_2.AccordionIcon, null)),
                        react_1.default.createElement(react_2.AccordionPanel, null,
                            react_1.default.createElement(SankeyMenuConfigurationLinks_1.default, { dict_variable_application_data: dict_variable_application_data, applicationContext: applicationContext, dict_variable_elements_selected: dict_variable_elements_selected, menu_configuration_links: menu_configuration_links, link_function: link_function, ComponentUpdater: ComponentUpdater, contextMenu: contextMenu, uiElementsRef: uiElementsRef, alt_key_pressed: alt_key_pressed, dict_hook_ref_setter_show_dialog_components: dict_hook_ref_setter_show_dialog_components, node_function: node_function }))),
                    additional_accordion_edition_elements))),
        show_menu_config_tag ?
            react_1.default.createElement(react_2.AccordionItem, null,
                react_1.default.createElement(react_2.AccordionButton, null,
                    react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfig_entry' }, t('Menu.Etiquettes')),
                    react_1.default.createElement(react_2.AccordionIcon, null)),
                react_1.default.createElement(react_2.AccordionPanel, null,
                    react_1.default.createElement(react_2.Accordion, { allowToggle: true, variant: "accordion_sublevel_style" },
                        react_1.default.createElement(react_2.AccordionItem, { style: { 'display': (data.accordeonToShow.includes('EN')) ? 'initial' : 'none' } },
                            react_1.default.createElement(react_2.AccordionButton, null,
                                react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'submenuconfig_entry' }, t('Menu.EN')),
                                react_1.default.createElement(react_2.AccordionIcon, null)),
                            react_1.default.createElement(react_2.AccordionPanel, null, menu_configuration_node_tags)),
                        react_1.default.createElement(react_2.AccordionItem, { style: { 'display': (data.accordeonToShow.includes('EF')) ? 'initial' : 'none' } },
                            react_1.default.createElement(react_2.AccordionButton, null,
                                react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'submenuconfig_entry' }, t('Menu.EF')),
                                react_1.default.createElement(react_2.AccordionIcon, null)),
                            react_1.default.createElement(react_2.AccordionPanel, null, menu_configuration_link_tags)),
                        react_1.default.createElement(react_2.AccordionItem, { style: { 'display': (data.accordeonToShow.includes('ED')) ? 'initial' : 'none' } },
                            react_1.default.createElement(react_2.AccordionButton, null,
                                react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'submenuconfig_entry' }, t('Menu.ED')),
                                react_1.default.createElement(react_2.AccordionIcon, null)),
                            react_1.default.createElement(react_2.AccordionPanel, null, menu_configuration_data_tags))))) :
            react_1.default.createElement(react_1.default.Fragment, null)
    ];
};
exports.OpenSankeyConfigurationsMenus = OpenSankeyConfigurationsMenus;
const SankeyConfigurationMenu = ({ configuration_menus }) => {
    return (react_1.default.createElement(react_2.Accordion, { allowToggle: true }, configuration_menus.map((c, i) => {
        return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
    })));
};
exports.SankeyConfigurationMenu = SankeyConfigurationMenu;
